<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<mat-card appearance="raised" class="settings-card">

<div style="display:flex; justify-content: space-between;">
    <div style="margin-right: 25px">
        <div>
            <app-language-selector
                label="{{'EMAIL_NOTIFICATION_LABEL' | translate}}"
                [selectedLanguage]="settings.email_notify_language"
                (valueChange)="onLanguageChanged($event)">
            </app-language-selector>
        </div>
    </div>
    <div>
        <div style="margin-right: 25px;">
            <mat-form-field appearance="outline">
                <mat-label>{{fEmailFreq}}</mat-label>
                <mat-select color="primary" [(ngModel)]="settings.alert_frequency" (valueChange)="isDirty = true">
                    <mat-option value="never">{{fTNever}}</mat-option>
                    <mat-option value="5-minutely">{{fT5Min}}</mat-option>
                    <mat-option value="hourly">{{fTHour}}</mat-option>
                    <mat-option value="daily">{{fTDay}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div>
        <div>
            <mat-form-field appearance="outline">
                <mat-label>{{fEventSeverity}}</mat-label>
                <mat-select color="primary" [(ngModel)]="settings.severity_notify" (valueChange)="isDirty = true">
                    <mat-option [value]=0>{{fTNever}}</mat-option>
                    <mat-option [value]=20>{{fEInfo}}</mat-option>
                    <mat-option [value]=30>{{fEWarning}}</mat-option>
                    <mat-option [value]=40>{{fEError}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div>
        <div class="button-wrapper">
            <button type="button" (click)="getSettings()" mat-raised-button [disabled]="!isDirty">{{fCancel}}</button>
            <button type="button" (click)="save()" color="primary" mat-raised-button [disabled]="!isDirty">{{fSave}}</button>
        </div>
    </div>
</div>

<div class="prefs-container">
    <table class="prefs-table" aria-describedby="List of notifications">
        <thead>
            <tr>
                <th class="type-header">{{fType}}</th>
                <th>{{fEmail}}<br /><mat-checkbox [(ngModel)]="selectAllEmail" [(indeterminate)]="selectAllEmailIndeterminate" color="primary" (change)="selectAllEmailChanged($event)" matTooltip="{{fEmailTip}}" aria-label="{{fEmailNoti}}"></mat-checkbox></th>
                <th>{{fInApp}}<br /><mat-checkbox [(ngModel)]="selectAllInApp" [(indeterminate)]="selectAllInAppIndeterminate" color="primary" (change)="selectAllInAppChanged($event)" matTooltip="{{fInAppTip}}" aria-label="{{fInAppNoti}}"></mat-checkbox></th>
            </tr>
        </thead>
        <tbody class="prefs-table-body">
            <tr *ngFor="let pref of prefs">
                <td>{{ pref.displayValue }}</td>
                <td class="email-td"><mat-checkbox [(ngModel)]="pref.email" color="primary" (change)="resetSelectAllCheckboxes()" aria-label="{{fEmailFor}} {{pref.displayValue}}"></mat-checkbox></td>
                <td class="in-app-td"><mat-checkbox [(ngModel)]="pref.in_app" color="primary" (change)="resetSelectAllCheckboxes()" aria-label="{{fInAppFor}} {{pref.displayValue}}"></mat-checkbox></td>
            </tr>
        </tbody>
    </table>
</div>

</mat-card>
